<button nw-ghost-button size="s" class="menu-item" [disabled]="disabled">
    <ng-content></ng-content>
</button>
